const API_BASE: string = (process.env.REACT_APP_API_BASE || "http://localhost:5000").replace(/\/$/, "");

function authHeaders(): Record<string, string> {
    const token = localStorage.getItem("token");
    return {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
}

async function handleResponse<T>(res: Response): Promise<T> {
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.message || `Pulse failed: ${res.status}`);
    return data as T;
}

export type PulseTopic = {
    id: string;
    label: string;
};

export type PulseNewsItem = {
    id: string;
    title: string;
    summary: string;
    why: string;
    source: string;
    url: string;
    topic: string;
    topicLabel: string;
    publishedAt: string;
};

export type PulseCommunity = {
    tags: Array<{ tag: string; count: number }>;
    spaces: Array<{ id: string; name: string; count: number }>;
};

export type PulsePage = {
    topics: PulseTopic[];
    brief: PulseNewsItem[];
    news: PulseNewsItem[];
    community: PulseCommunity;
    total: number;
    nextCursor: string | null;
    hasMore: boolean;
    source: string;
    updatedAt: string;
    stale?: boolean;
};

export async function fetchPulse(params: {
    topic?: string;
    q?: string;
    cursor?: string | null;
    limit?: number;
    signal?: AbortSignal;
} = {}): Promise<PulsePage> {
    const url = new URL(`${API_BASE}/api/pulse`);
    if (params.topic && params.topic !== "all") url.searchParams.set("topic", params.topic);
    if (params.q?.trim()) url.searchParams.set("q", params.q.trim());
    if (params.cursor) url.searchParams.set("cursor", params.cursor);
    if (params.limit) url.searchParams.set("limit", String(params.limit));
    const data = await handleResponse<any>(await fetch(url.toString(), {
        headers: authHeaders(),
        signal: params.signal,
    }));
    return {
        topics: data.topics || [],
        brief: data.brief || [],
        news: data.news || [],
        community: data.community || { tags: [], spaces: [] },
        total: data.total || 0,
        nextCursor: data.nextCursor || null,
        hasMore: Boolean(data.hasMore),
        source: data.source || "World",
        updatedAt: data.updatedAt || new Date().toISOString(),
        stale: Boolean(data.stale),
    };
}
